import styled, { css, keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const skeletonStyles = css`
  animation: ${shimmer} 1.5s ease-in-out infinite;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 0px, rgba(0, 0, 0, 0.1) 40px, rgba(0, 0, 0, 0.06) 80px);
  background-size: 200px 100%;
`;

// Menu Image Banner Placeholder Styles
export const BannerWrapper = styled.div`
  margin: 20px auto 0;
  max-width: 1200px;
  padding: 0 16px;

  @media (min-width: 770px) {
    padding: 0;
  }
`;

export const BannerSkeleton = styled.div`
  aspect-ratio: 2.22 / 1;
  background: rgba(0, 0, 0, 0.05);
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  width: 100%;

  @media (min-width: 600px) {
    aspect-ratio: 3 / 1;
  }
`;

// Categories Nav Placeholder Styles
export const CategoriesWrapper = styled.div`
  margin: 32px auto 0;
  max-width: ${({ theme }) => theme.customized.maxSiteWidth}px;
`;

export const CategoriesWrapperShift = styled.div`
  margin: 0 -16px;
`;

export const CategoriesHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0 16px;
  width: 100%;
`;

export const CategoriesHeading = styled.div`
  ${skeletonStyles}
  border-radius: 4px;
  height: 24px;
  width: 120px;

  @media screen and (min-width: 600px) {
    height: 31px;
    width: 150px;
  }
`;

export const CategoriesSliderContainer = styled.div`
  position: relative;
`;

export const CategoriesViewport = styled.div`
  overflow-x: hidden;
  width: 100%;
`;

export const CategoriesItems = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px 16px;
`;

export const CategoryCardSkeleton = styled.div`
  ${skeletonStyles}
  border-radius: 12px;
  flex-shrink: 0;
  height: 121px;
  width: 146px;

  @media screen and (min-width: 600px) {
    height: 145px;
    width: 184px;
  }
`;
